
import {getLanguage} from 'react-multi-lang'

export const msgs= {
 required_msg : getLanguage()==='en'?"This field is required":"هذا الحقل مطلوب",
 min_msg :(num:number)=> getLanguage()==='en'?`This field should be greater or equal ${num}`
                                  :`هذا الحقل يجب أن يكون أكبر او يساوي ${num}`,
 max_msg: (num:number)=> getLanguage()==='en'?`This field should be less or equal ${num}`
 :`هذا الحقل يجب أن يكون أصغر او يساوي ${num}`,                                
 valid_client_number:getLanguage()==="en"?"Please enter a valid client number":"رجاءا أدحل رقم عميل صالح",
 date_from_to: getLanguage()==='en'?'End date must be later than start date':"تاريخ من يجب أن يكون أصغر من تاريخ الى",
 file_larg:getLanguage()==='en'?"This file size is larger than 5 MB":"حجم الملف تجاوز الحد المسموح به 5 MB",
 file_type:getLanguage()==='en'?"file types that are allowed jpg/png/pdf/jpeg":"الملف يجب أن يكون أحد الأنواع التالية: jpg/jpeg/png/pdf.",
 file_invalid: getLanguage() ==='en'?"File type or size is invalid":"الملف غير صالح , حجم الملف أو نوعه غير صالح"
}

